import React from 'react'
import Navbar from './../components/Navbar/index';
import Sidebar from './../components/Sidebar/Sidebar';
import Description from './../components/Description'
import Alert from './../library/Alert'
import Avatar from './../library/Avatar'
import Badge from './../library/Badge'
import Button from './../library/Button'
import Card from './../library/Card'
import Grid from './../library/Grid'
import Image from './../library/Image'
import Input from './../library/Input'

// import Modal from './../library/Modal'
import { Switch,Route } from 'react-router-dom';

const Main = () => {
  return (
    <div className="main" id="main">
      <Navbar />
      <Sidebar />
      <Switch>
          <Route exact path='/main'>
              <Description />
          </Route>
          <Route exact path='/main/intro'>
              <Description />
          </Route>
          <Route exact path='/main/alert'>
              <Alert />
          </Route>
          <Route exact path='/main/avatar'>
              <Avatar />
          </Route>
          <Route exact path='/main/badge'>
              <Badge />
          </Route>
          <Route exact path='/main/button'>
              <Button />
          </Route>
          <Route exact path='/main/card'>
              <Card />
          </Route>
          <Route exact path='/main/grid'>
              <Grid />
          </Route>
          <Route exact path='/main/image'>
              <Image />
          </Route>
          <Route exact path='/main/input'>
              <Input />
          </Route>
          {/* <Route exact path='/main/modal'>
              <Modal />
          </Route> */}
      </Switch>

    </div>
  )
}

export default Main